import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const newsletterPreviewHtmlReducer: RemoteReducer<string> =
  createRemoteReducer("newsletterPreviewHtml")
